import {metadaApi} from '@dms/api/base';

import {
  PostTransferOrderItemRequest,
  PostTransferOrderItemResponse,
  PostTransferOrderItemRequestSchema,
  PostTransferOrderItemResponseSchema,
  DeleteTransferOrderItemResponse,
  DeleteTransferOrderItemRequest,
  DeleteTransferOrderItemRequestSchema,
  DeleteTransferOrderItemResponseSchema,
  PatchTransferOrderItemResponse,
  PatchTransferOrderItemRequest,
  PatchTransferOrderItemRequestSchema,
  PatchTransferOrderItemResponseSchema,
  GetTransferOrderItemResponse,
  GetTransferOrderItemRequest,
  GetTransferOrderItemRequestSchema,
  GetTransferOrderItemResponseSchema,
} from './types';

export const metadaWarehouseTransferOrderItemApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getTransferOrderItem: build.query<GetTransferOrderItemResponse, GetTransferOrderItemRequest>({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order/${queryArg.transferOrderId}/item/${queryArg.transferOrderItemId}`,
        method: 'GET',
        queryArg,
      }),
      extraOptions: {
        requestSchema: GetTransferOrderItemRequestSchema,
        responseSchema: GetTransferOrderItemResponseSchema,
      },
    }),
    postTransferOrderItem: build.mutation<
      PostTransferOrderItemResponse,
      PostTransferOrderItemRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order/${queryArg.transferOrderId}/item`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'transferOrderBasket', id: queryArg.transferOrderId},
      ],
      extraOptions: {
        requestSchema: PostTransferOrderItemRequestSchema,
        responseSchema: PostTransferOrderItemResponseSchema,
      },
    }),
    patchTransferOrderItem: build.mutation<
      PatchTransferOrderItemResponse,
      PatchTransferOrderItemRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order/${queryArg.transferOrderId}/item/${queryArg.transferOrderItemId}`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'transferOrderBasket', id: queryArg.transferOrderId},
        {type: 'transferOrderItems', id: queryArg.transferOrderItemId},
      ],
      extraOptions: {
        requestSchema: PatchTransferOrderItemRequestSchema,
        responseSchema: PatchTransferOrderItemResponseSchema,
      },
    }),
    deleteTransferOrderItem: build.mutation<
      DeleteTransferOrderItemResponse,
      DeleteTransferOrderItemRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order/${queryArg.transferOrderId}/item/delete`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'transferOrderBasket', id: queryArg.transferOrderId},
      ],
      extraOptions: {
        requestSchema: DeleteTransferOrderItemRequestSchema,
        responseSchema: DeleteTransferOrderItemResponseSchema,
      },
    }),
  }),
});

export const {
  useGetTransferOrderItemQuery,
  useLazyGetTransferOrderItemQuery,
  usePostTransferOrderItemMutation,
  usePatchTransferOrderItemMutation,
  useDeleteTransferOrderItemMutation,
} = metadaWarehouseTransferOrderItemApi;
